<template>
<div>
  <v-layout row justify-center>
    <v-flex xs12 sm10 md9 lg8>
      <v-card flat>
        <v-layout row wrap justify-center>
          <v-flex class="px-2" xs12 sm6>
            <v-select
              label="Question Type"
              v-model="newQuestion.type"
              :items="['True/False', 'Multiple Choice', 'Select All That Apply', 'Priority']"
              disabled
              autofocus
              hide-details
            ></v-select>
          </v-flex>
          <v-flex class="px-2" xs12>
            <v-select
              label="Tags"
              v-model="newQuestion.tags"
              :items="allTags"
              :disabled="newQuestion.type == ''"
              hint="Click Manage Tags to view and manage tags in the system"
              persistent-hint
              multiple
              chips
            ></v-select>
          </v-flex>
          <v-flex class="px-2 text-xs-center" xs12>
            <v-btn @click.native="popup.type = 'Tags', popup.show = true" class="my-0 primary" depressed small>
              Manage Tags
            </v-btn>
          </v-flex>
          <v-flex class="px-2" xs12>
            <v-select
              label="NCLEX Area"
              v-model="newQuestion.area"
              :items="nclexAreas"
              :disabled="newQuestion.type == ''"
              hint="Click Manage NCLEX Areas to view and manage all NCLEX areas in the system"
              persistent-hint
              multiple
              chips
            ></v-select>
          </v-flex>
          <v-flex class="px-2 text-xs-center" xs12>
            <v-btn @click.native="popup.type = 'NCLEX Areas', popup.show = true" class="my-0 primary" depressed small>
              Manage NCLEX Areas
            </v-btn>
          </v-flex>
          <v-flex class="px-2" xs12>
            <v-text-field
              label="Question"
              v-model="newQuestion.body"
              rows="3"
              :disabled="newQuestion.type == ''"
              hide-details
              textarea
            ></v-text-field>
          </v-flex>
          <v-flex class="px-2 pb-2" xs12>
            <v-text-field
              label="Rationale"
              v-model="newQuestion.rationale"
              rows="2"
              :disabled="newQuestion.type == ''"
              hide-details
              textarea
            ></v-text-field>
          </v-flex>
          <v-flex class="px-2 pb-2 text-xs-center" xs12>
            <v-btn @click.native="createAnswer" class="primary" :disabled="newQuestion.type == ''" depressed small>
              Add Answer Choice
            </v-btn>
            <div v-if="newQuestion.answers" class="pt-3">
              <span v-if="newQuestion.answers.length > 0" class="title grey--text text--darken-2">Check the box of the correct answer(s)</span>
              <span v-else class="display-1 grey--text text--lighten-1">Please add answer choices</span>
            </div>
          </v-flex>
          <v-flex class="px-2 pb-3" xs12>
            <v-card v-for="answer,index in newQuestion.answers" :key="index" class="pa-2 mb-2 elevation-1 grey lighten-4">
              <r-answer
                :answer="answer"
                :question-type="newQuestion.type"
                @correct="setCorrectAnswer(index)"
                @delete="toDelete = index, popup.type = 'Deleting Answer', popup.show = true"
              ></r-answer>
            </v-card>
          </v-flex>
          <v-flex class="px-2 pb-3 text-xs-center" xs12>
            <v-btn @click.native="canSave" class="my-0" color="success" :loading="loading" :disabled="!questionChanged || loading" large>
              Save
            </v-btn>
            <v-btn @click.native="popup.type = 'Resetting', popup.show = true" class="my-0" color="error" large flat>
              <b>Reset</b>
            </v-btn>
          </v-flex>
          <v-flex class="px-2 py-4" xs12>
            <v-divider></v-divider>
          </v-flex>
          <v-flex class="px-2 pb-4 text-xs-center" xs12 md10>
            <v-btn 
              @click.native="questionToDelete = newQuestion.id, popup.show = true, popup.type = 'Deleting Question'"
              color="error"
              :loading="deleting"
              :disabled="deleting"
              large
            >Delete Question</v-btn>
          </v-flex>
        </v-layout>
      </v-card>
    </v-flex>
  </v-layout>

  <r-question-popup
    :popup="popup"
    :all-tags="allTags"
    :nclex-areas="nclexAreas"
    :question-id="questionToDelete"
    @reset="loadQuestion"
    @addQuestion="updateQuestion"
    @removeAnswer="removeAnswer"
    @addTag="addTag($event)"
    @addArea="addNclexArea($event)"
    @deleteQuestion="deleteQuestion"
  ></r-question-popup>
</div>
</template>

<script>
import AnswerCard from './AnswerCard.vue'
import QuestionPopup from './QuestionPopup.vue'
export default {
  props: ['questionData'],
  components: {
    rAnswer: AnswerCard,
    rQuestionPopup: QuestionPopup
  },
  data: () => ({
    loading: false,
    deleting: false,
    newQuestion: {},
    newTag: '',
    allTags: [],
    nclexAreas: [],
    questionToDelete: null,
    toDelete: null,
    popup: {
      show: false,
      type: ''
    }
  }),
  computed: {
    questionChanged () {
      if (typeof this.newQuestion === 'undefined' || typeof this.questionData === 'undefined') return true
      let body = this.newQuestion.body !== this.questionData.body
      let rationale = this.newQuestion.rationale !== this.questionData.rationale
      let tags = false
      let area = false
      let answers = false
      if (this.newQuestion.tags && this.questionData.tags) {
        if (this.newQuestion.tags.length === this.questionData.tags.length) {
          for (let i = 0; i < this.newQuestion.tags.length; i++) {
            if (this.newQuestion.tags[i] !== this.questionData.tags[i]) tags = true
          }
        } else tags = true
      }
      if (this.newQuestion.area && this.questionData.area) {
        if (this.newQuestion.area.length === this.questionData.area.length) {
          for (let i = 0; i < this.newQuestion.area.length; i++) {
            if (this.newQuestion.area[i] !== this.questionData.area[i]) area = true
          }
        } else area = true
      }
      if (this.newQuestion.answers && this.questionData.answers) {
        if (this.newQuestion.answers.length === this.questionData.answers.length) {
          for (let i = 0; i < this.newQuestion.answers.length; i++) {
            if (this.newQuestion.answers[i].text !== this.questionData.answers[i].text) answers = true
            if (this.newQuestion.answers[i].correct !== this.questionData.answers[i].correct) answers = true
          }
        } else answers = true
      }
      return body || rationale || tags || area || answers
    }
  },
  beforeMount () {
    this.loadQuestion()
    this.getTags()
    this.getNclexAreas()
  },
  methods: {
    loadQuestion () {
      this.newQuestion = {
        ...this.questionData,
        tags: this.questionData.tags ? [...this.questionData.tags] : [],
        area: this.questionData.area ? [...this.questionData.area] : [],
        answers: []
      }
      for (let a of this.questionData.answers) {
        this.newQuestion.answers.push({...a})
      }
      this.popup.show = false
    },
    getTags () {
      this.allTags = [...this.$store.getters.tags.sort()]
    },
    getNclexAreas () {
      this.nclexAreas = [...this.$store.getters.nclexAreas.sort()]
    },
    answerError () {
      const appMsg = {
        type: 'error',
        msg: ''
      }
      if (this.newQuestion.answers.length < 2) {
        appMsg.msg = 'Questions must have 2 or more answer choices'
        this.$store.dispatch('showAppMsg', appMsg)
        return true
      } else {
        if (this.newQuestion.type === 'Matching/Dropdown') {
          for (let i = 0; i < this.newQuestion.answers.length; i++) {
            if (this.newQuestion.answers[i].text === '' || this.newQuestion.answers[i].correct === '') {
              appMsg.msg = 'Please fill the text of all matching options'
              this.$store.dispatch('showAppMsg', appMsg)
              return true
            }
          }
          return false
        } else {
          for (let i = 0; i < this.newQuestion.answers.length; i++) {
            if (this.newQuestion.answers[i].text === '') {
              appMsg.msg = 'Please fill the text of all answer choices'
              this.$store.dispatch('showAppMsg', appMsg)
              return true
            }
          }
          for (let i = 0; i < this.newQuestion.answers.length; i++) {
            if (this.newQuestion.answers[i].correct) return false
          }
          appMsg.msg = 'Please select the correct answer'
          this.$store.dispatch('showAppMsg', appMsg)
          return true
        }
      }
    },
    canSave () {
      const appMsg = {
        type: 'error',
        msg: ''
      }
      if (this.newQuestion.body === '') {
        appMsg.msg = 'Question body is empty'
        this.$store.dispatch('showAppMsg', appMsg)
        return
      }
      if (!this.answerError()) {
        if (this.newQuestion.rationale === '' || this.newQuestion.tags.length === 0) {
          this.popup.type = 'Warning'
          this.popup.show = true
        } else {
          this.updateQuestion()
        }
      }
    },
    updateQuestion () {
      this.loading = true
      this.$store.dispatch('updateQuestion', this.newQuestion).then(() => {
        const appMsg = {
          type: 'success',
          msg: 'Question ' + this.questionData.id + ' updated!'
        }
        this.$store.dispatch('showAppMsg', appMsg)
        this.$emit('updated')
        this.loading = false
      })
    },
    createAnswer () {
      if (this.newQuestion.answers.length >= 10) {
        const appMsg = {
          type: 'error',
          msg: 'Too many answers!'
        }
        this.$store.dispatch('showAppMsg', appMsg)
        return
      }
      let l = String.fromCharCode(this.newQuestion.answers.length + 65)
      if (this.newQuestion.type === 'True/False') {
        if (this.newQuestion.answers.length > 1) return
        this.newQuestion.answers.push({letter: l, text: 'True', correct: false})
        l = String.fromCharCode(this.newQuestion.answers.length + 65)
        this.newQuestion.answers.push({letter: l, text: 'False', correct: false})
      } else if (this.newQuestion.type === 'Matching/Dropdown') {
        if (this.newQuestion.answers.length === 0) {
          for (let i = 0; i < 4; i++) {
            l = String.fromCharCode(this.newQuestion.answers.length + 65)
            this.newQuestion.answers.push({letter: l, text: '', correct: ''})
          }
        } else {
          this.newQuestion.answers.push({letter: l, text: '', correct: ''})
        }
      } else {
        if (this.newQuestion.answers.length === 0) {
          for (let i = 0; i < 4; i++) {
            l = String.fromCharCode(this.newQuestion.answers.length + 65)
            this.newQuestion.answers.push({letter: l, text: '', correct: false})
          }
        } else {
          this.newQuestion.answers.push({letter: l, text: '', correct: false})
        }
      }
    },
    removeAnswer () {
      this.newQuestion.answers.splice(this.toDelete, 1)
      for (let i = 0; i < this.newQuestion.answers.length; i++) {
        this.newQuestion.answers[i].letter = String.fromCharCode(65 + i)
      }
      this.popup.show = false
    },
    setCorrectAnswer (index) {
      if (this.newQuestion.type === 'Select All That Apply') {
        this.newQuestion.answers[index].correct = !this.newQuestion.answers[index].correct
      } else {
        for (let i = 0; i < this.newQuestion.answers.length; i++) {
          if (index === i) this.newQuestion.answers[i].correct = true
          else this.newQuestion.answers[i].correct = false
        }
      }
    },
    addTag (tag) {
      const tags = [...this.allTags]
      tags.push(tag)
      this.$store.dispatch('saveTags', tags).then(() => {
        const appMsg = {
          type: 'success',
          msg: 'Tag "' + tag + '" added!'
        }
        this.$store.dispatch('showAppMsg', appMsg)
        this.getTags()
        this.popup.type = 'Tags'
      })
    },
    addNclexArea (area) {
      const areas = [...this.nclexAreas]
      areas.push(area)
      this.$store.dispatch('saveNclexAreas', areas).then(() => {
        const appMsg = {
          type: 'success',
          msg: 'NCLEX Area: "' + area + '" saved'
        }
        this.$store.dispatch('showAppMsg', appMsg)
        this.getNclexAreas()
        this.popup.type = 'NCLEX Areas'
      })
    },
    deleteQuestion () {
      this.deleting = true
      const qId = this.newQuestion.id
      this.$store.dispatch('deleteQuestion', this.newQuestion).then(() => {
        const appMsg = {
          type: 'success',
          msg: 'Question ' + qId + ' was deleted'
        }
        this.deleting = false
        this.$store.dispatch('showAppMsg', appMsg)
        this.$router.push('/questions')
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/questions/EditQuestion.vue